export const GET_APPOINTMENT_LIST = "GET_APPOINTMENT_LIST";
export const GET_APPOINTMENT_LIST_FAIL = "GET_APPOINTMENT_LIST_FAIL";
export const GET_APPOINTMENT_LIST_SUCCESS = "GET_APPOINTMENT_LIST_SUCCESS";
export const GET_APPOINTMENT_LIST_RESET = "GET_APPOINTMENT_PAGE_WIDGET_RESET";

//getAppointmentList
export const getAppointmentList = (params) => {
  return { type: GET_APPOINTMENT_LIST, params };
};
export const getAppointmentListFail = (response) => {
  return { type: GET_APPOINTMENT_LIST_FAIL, response };
};
export const getAppointmentListSuccess = (response) => {
  return { type: GET_APPOINTMENT_LIST_SUCCESS, response };
};
export const getAppointmentListReset = () => {
  return { type: GET_APPOINTMENT_LIST_RESET };
};
